import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";

export class CompetitorsRequestParams extends BaseApiRequestParams {
  sports: Array<Number>;
  competitors: Array<Number>;
  limit: Number;
  promoteNational: Boolean;

  constructor(sports: Array<Number> = [], competitors: Array<Number> = [], isPopular: Boolean = false, limit: Number = 10, promoteNational: Boolean = false, withSeasons: Boolean = true, isDashboardRequest: Boolean = true) {
    let isPopularParams = (isPopular ? 'top/' : '');
    super('competitors/' + isPopularParams);

    this.sports = sports;
    this.competitors = competitors;
    this.limit = limit;
    this.promoteNational = promoteNational;
    this.withSeasons = withSeasons;
    this.isDashboardRequest = isDashboardRequest;
  }

  get competitorsParam() {
    return this.competitors && this.competitors.length > 0 ? `&competitors=${this.competitors.toString()}` : '';
  }

  get sportsParam() {
    return this.sports && this.sports.length > 0 ? `&sports=${this.sports.toString()}` : '';
  }

  get promoteNationalParam() {
    return this.promoteNational ? `&promoteNational=${this.promoteNational.toString()}` : '';
  }

  get withSeasonsParam() {
    return this.withSeasons ? `&withSeasons=${this.withSeasons}` : '';
  }

  get isDashboardRequestParam() {
    return this.isDashboardRequest ? `&isDashboard=${this.isDashboardRequest}` : '';
  }

  toString(): string {
    return super.toString() + this.sportsParam + this.competitorsParam + this.limitParam + this.promoteNationalParam + this.withSeasonsParam + this.isDashboardRequestParam;
  }

  get limitParam() {
    return this.limit ? `&limit=${this.limit}` : '';
  }

  get fullUrl(): string {
    return this.toString();
  }

  equals(model: CompetitorsRequestParams): Boolean {
    let equals = super.equals(model);

    equals &= this.competitorsParam === model.competitorsParam;
    equals &= this.sportsParam === model.sportsParam;
    equals &= this.limitParam === model.limitParam;
    equals &= this.promoteNationalParam === model.promoteNationalParam;
    equals &= this.withSeasonsParam === model.withSeasonsParam;
    equals &= this.isDashboardRequestParam === model.isDashboardRequestParam;

    return equals;
  }
}
